<template>
  <div class="modal-sio-container">
    <div class="sio-table">
      <div class="st-wrapper st-title">
        <div class="stw-no">
          No
        </div>
        <div class="stw-unit">
          Bisnis Unit
        </div>
        <div class="stw-number">
          Nomor
        </div>
        <div class="stw-activity">
          Kegiatan
        </div>
        <div class="stw-area">
          Area Kerja
        </div>
        <div class="stw-name">
          Nama PJO
        </div>
        <div class="stw-email">
          Email PJO
        </div>
        <div class="stw-department-title">
          Perusahaan Penanggung
        </div>
        <div
          class="stw-start-date stw-start-date__start-hover"
          @click="sortDate()"
        >
          Tgl Mulai
          <i class="fas fa-sort-numeric-down-alt" v-show="sortMode"></i
          ><i class="fas fa-sort-numeric-up" v-show="!sortMode"></i>
        </div>
        <div class="stw-end-date stw-end-date__end-hover" @click="sortDate2()">
          Tgl Berakhir
          <i class="fas fa-sort-numeric-down-alt" v-show="sortMode2"></i
          ><i class="fas fa-sort-numeric-up" v-show="!sortMode2"></i>
        </div>
      </div>
      <div v-if="sioData">
        <div class="st-wrapper" v-for="(item, index) in sioData" :key="index">
          <div class="stw-no">
            {{ index + 1 }}
          </div>
          <div class="stw-unit">
            {{ item.bisnis_unit }}
          </div>
          <div class="stw-number col-elipsis all-column">
            {{ item.nomor }}
          </div>
          <div class="stw-activity col-elipsis all-column">
            {{ item.kegiatan }}
          </div>
          <div class="stw-area col-elipsis all-column">
            {{ item.area_kerja }}
          </div>
          <div class="stw-name col-elipsis all-column">
            {{ item.nama_pjo }}
          </div>
          <div class="stw-email col-elipsis all-column">
            {{ item.email_pjo }}
          </div>
          <div class="stw-department col-elipsis all-column">
            {{ item.departemen_pjo }}
          </div>
          <div class="stw-start-date">
            {{ formatDate(item.start_date) }}
          </div>
          <div class="stw-end-date">
            {{ formatDate(item.end_date) }}
          </div>
        </div>
      </div>
      <div class="st-button-wrapper" v-if="editingStatus && editingUser">
        <div class="st-button-act pointer" @click="addRows()">
          Tambah Baris
        </div>
        <!-- <div class="st-button-act" @click="delLastRow()">
            Hapus Baris Terakhir
          </div> -->
      </div>
    </div>
    <Edit v-if="$store.state.modalStore.showSio" />
  </div>
</template>
<script>
export default {
  components: {
    Edit: () => import('@/components/modal/sio.vue'),
  },
  data() {
    return {
      sortMode: false,
      sortMode2: false,
    }
  },
  computed: {
    sioData() {
      return this.$store.state.level1.sioData
    },
    editingStatus() {
      return this.$get(this.$store, 'state.editingStore.sio_level_1.is_open', 0)
    },
    editingUser() {
      return (
        this.$get(this.$store, 'state.editingStore.sio_level_1.user_id', '') ==
        this.$get(this.$store, 'state.userid', 0)
      )
    },
  },
  methods: {
    sortDate() {
      this.sortMode = !this.sortMode
    },
    sortDate2() {
      this.sortMode2 = !this.sortMode2
    },
    addRows() {
      this.$store.commit('modalStore/SHOW_SIO')
    },
    delLastRow() {
      this.sioData.pop()
    },
  },
}
</script>
